import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './routes/Router';
/*import { AuthProvider } from './context/AuthContext';*/
import 'bootstrap/dist/css/bootstrap.min.css'; // Asegúrate de tener bootstrap instalado

const App = () => {
  return (
    <BrowserRouter>      
        <Router />      
    </BrowserRouter>
  );
};

export default App;